module.exports = __webpack_public_path__ + "static/media/keras.e58ce345.svg";